import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../config";

export const getAllCategories = createAsyncThunk(
  "product/getAllCategories",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/categories`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message);
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: localStorage.getItem("categories")
      ? JSON.parse(localStorage.getItem("categories"))
      : [],
    loading: false,
    error: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategories.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.categories = [...action.payload.categories];
        localStorage.setItem(
          "categories",
          JSON.stringify(action.payload.categories)
        );
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export default categorySlice.reducer;
